import { InsuranceCardActions } from '../../actions/InsuranceCardActions';
import { InsuranceCardFetchActions } from '../../actions/InsuranceCardFetch';
import * as AppointmentRequirementActions from '../../components/AppointmentRequirements/AppointmentRequirementsActions';
import { MEMBER_ID_SOURCE_TYPE } from '../../constants';
import * as Actions from './AppointmentDetailsActions';

const defaultState = {
    phoneNumber: '',
    submittingBookingState: false,
    insuranceId: '',
    insuranceError: false,
    doctorNotes: '',
    insuranceCarrier: '',
    insurancePlan: '',
    insuranceIdSourceType: undefined,
    gettingInsuranceCarrierName: false,
    gettingInsurancePlanName: false,
    disableContinue: true,
};

export const appointmentDetailsReducer = (state = defaultState, action) => {
    switch (action.type) {
        case InsuranceCardFetchActions.SUCCESS: {
            return {
                ...state,
                disableContinue: false,
            };
        }

        case InsuranceCardFetchActions.FAILED: {
            return {
                ...state,
                disableContinue: false,
            };
        }

        case Actions.AppointmentDetailsActions.ENTER_INSURANCE_ID: {
            return {
                ...state,
                insuranceId: action.insuranceId,
                insuranceError: false,
                insuranceIdSourceType: action.insuranceIdSourceType,
            };
        }

        case InsuranceCardActions.SELECTED: {
            if (
                !state.insuranceId ||
                state.insuranceId.length === 0 ||
                state.insuranceIdSourceType ===
                    MEMBER_ID_SOURCE_TYPE.INSURANCE_API
            ) {
                return {
                    ...state,
                    insuranceId: action.payload.memberIdFromCard || '',
                    insuranceError: false,
                    insuranceIdSourceType: MEMBER_ID_SOURCE_TYPE.INSURANCE_API,
                };
            }

            return state;
        }
        case InsuranceCardActions.SHARE_CLICKED: {
            const { isInsuranceCardShared, memberIdFromCard } = action.payload;

            if (isInsuranceCardShared && memberIdFromCard) {
                return {
                    ...state,
                    insuranceId: memberIdFromCard,
                    insuranceError: false,
                    insuranceIdSourceType: MEMBER_ID_SOURCE_TYPE.INSURANCE_API,
                };
            } else if (!isInsuranceCardShared) {
                return {
                    ...state,
                    insuranceId: '',
                    insuranceError: false,
                    insuranceIdSourceType: MEMBER_ID_SOURCE_TYPE.PATIENT_INPUT,
                };
            }

            return state;
        }

        case Actions.AppointmentDetailsActions.TRIM_INSURANCE_ID: {
            const insuranceId = state.insuranceId
                ? state.insuranceId.trim()
                : state.insuranceId;
            return {
                ...state,
                insuranceId,
            };
        }

        case Actions.AppointmentDetailsActions.ENTER_DOCTOR_NOTES: {
            return {
                ...state,
                doctorNotes: action.doctorNotes,
            };
        }

        case Actions.AppointmentDetailsActions.GETTING_INSURANCE_CARRIER_NAME: {
            return {
                ...state,
                gettingInsuranceCarrierName: true,
            };
        }

        case Actions.AppointmentDetailsActions
            .GET_INSURANCE_CARRIER_NAME_SUCCESS: {
            return {
                ...state,
                insuranceCarrier: action.insuranceCarrier,
                gettingInsuranceCarrierName: false,
            };
        }

        case Actions.AppointmentDetailsActions
            .GET_INSURANCE_CARRIER_NAME_FAILURE: {
            return {
                ...state,
                gettingInsuranceCarrierName: false,
            };
        }

        case Actions.AppointmentDetailsActions.GETTING_INSURANCE_PLAN_NAME: {
            return {
                ...state,
                gettingInsurancePlanName: true,
            };
        }

        case Actions.AppointmentDetailsActions
            .GET_INSURANCE_PLAN_NAME_SUCCESS: {
            return {
                ...state,
                insurancePlan: action.insurancePlan,
                gettingInsurancePlanName: false,
            };
        }

        case Actions.AppointmentDetailsActions
            .GET_INSURANCE_PLAN_NAME_FAILURE: {
            return {
                ...state,
                gettingInsurancePlanName: false,
            };
        }

        case AppointmentRequirementActions.SHOW_VALIDATION_ERRORS: {
            if (action.insuranceIdRequired) {
                const insuranceNotCompleted =
                    !state.insuranceId || state.insuranceId.trim() === '';

                if (insuranceNotCompleted) {
                    return {
                        ...state,
                        insuranceError: true,
                    };
                }
            }

            return {
                ...state,
            };
        }

        default:
            return state;
    }
};
